function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18.5 4H1.5M16.833 6.5L16.373 13.4C16.196 16.054 16.108 17.381 15.243 18.19C14.378 18.999 13.047 19 10.387 19H9.613C6.953 19 5.622 19 4.757 18.19C3.892 17.381 3.803 16.054 3.627 13.4L3.167 6.5M7.5 9L8 14M12.5 9L12 14",
    stroke: "#1A4338",
    style: {
      stroke: "#1A4338",
      stroke: "color(display-p3 0.1020 0.2627 0.2196)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 4H4.61C5.01245 3.98972 5.40242 3.85822 5.72892 3.62271C6.05543 3.3872 6.30325 3.05864 6.44 2.68L6.474 2.577L6.571 2.286C6.654 2.037 6.696 1.913 6.751 1.807C6.85921 1.59939 7.01451 1.41999 7.20448 1.28316C7.39444 1.14633 7.6138 1.05586 7.845 1.019C7.962 1 8.093 1 8.355 1H11.645C11.907 1 12.038 1 12.155 1.019C12.3862 1.05586 12.6056 1.14633 12.7955 1.28316C12.9855 1.41999 13.1408 1.59939 13.249 1.807C13.304 1.913 13.346 2.037 13.429 2.286L13.526 2.577C13.6527 2.99827 13.9148 3.36601 14.2717 3.62326C14.6285 3.88051 15.0603 4.01293 15.5 4",
    stroke: "#1A4338",
    style: {
      stroke: "#1A4338",
      stroke: "color(display-p3 0.1020 0.2627 0.2196)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteDark);
export default __webpack_public_path__ + "static/media/delete_dark.2fda8d4529e98f337bda381648277f33.svg";
export { ForwardRef as ReactComponent };